import React from "react";
import ReactDOM from "react-dom";

import styled from "styled-components";

import ForgotPass from "./ForgotPass";
import NewButton from "./FormComponents/NewButton";
import NewInput from "./FormComponents/NewInput";
import userIcon from "../images/user-icon.svg";
import password from "../images/password.svg";
import { API_ROOT, colors, checkStatus, parseJSON } from "../util/constants";

class LoginWithPass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: props.redirect,
      user: "",
      password: "",
      error: false,
      errorText: "",
      processing: false
    };
  }
  handleEmail = e => {
    this.setState({
      user: e.target.value
    });
  };

  handlePassword = e => {
    this.setState({
      password: e.target.value
    });
  };

  login = e => {
    e.preventDefault();
    if (this.state.user !== "" && this.state.password !== "") {
      this.setState({ processing: true });
      var myRequestUrl = API_ROOT + "login.php";
      var formData = new FormData();

      formData.append("user", this.state.user);
      formData.append("password", this.state.password);

      var self = this;
      fetch(myRequestUrl, {
        method: "POST",
        body: formData,
        credentials: "same-origin"
      })
        .then(checkStatus)
        .then(parseJSON)
        .then(function(data) {
          if (data.status) {
            window.location.href = self.props.redirect;
          } else {
            self.setState({
              error: true,
              errorText: "Invalid user or password.",
              processing: false
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    } else {
      this.setState({ error: true, errorText: "All fields are mandatory." });
    }
  };

  redirectSignup = () => {
    window.location.href = "/signup";
  };

  loginWithOtp = () => {
    this.props.loginUsingotps();
  };
  forgotPass = () => {
    ReactDOM.render(<ForgotPass />, document.getElementById("login-container"));
  };
  render() {
    return (
      <form method="post" onSubmit={this.login}>
        <div className="normal-login-manual">
          <NewInput
            type="email"
            autoComplete="email"
            placeholder="Registered Email"
            autoFocus={true}
            required={true}
            onChange={this.handleEmail}
            value={this.state.user}
            margin="0 0 10px 0"
            leftIcon={userIcon}
            error={this.state.error}
          />
          <NewInput
            type="password"
            placeholder="Password"
            required={true}
            onChange={this.handlePassword}
            value={this.state.password}
            margin="0 0 10px 0"
            leftIcon={password}
            error={this.state.error}
          />
          {this.state.error && <ErrorText>{this.state.errorText}</ErrorText>}
          <NewButton type="submit" block disabled={this.state.processing}>
            {this.state.processing ? "Submitting.." : "Login"}
          </NewButton>
          <NewButton
            type="button"
            onClick={this.loginWithOtp}
            block
            secondary
            border="1px solid #a0a0a0"
          >
            Login using OTP
          </NewButton>
          <div className="forgot-sign-up-block">
            <Link href="/signup">Don’t have an account? Sign up</Link>
            <ForgotPassword onClick={this.forgotPass}>
              Forgot password?
            </ForgotPassword>
          </div>
        </div>
      </form>
    );
  }
}

const Link = styled.a`
  color: #42a5f5 !important;
  font-size: 0.9rem !important;
  text-decoration: none !important;
  user-select: none !important;
  &:hover {
    text-decoration: none !important;
    color: #3ca0c8 !important;
  }
`;

const ForgotPassword = styled.span`
  color: #42a5f5 !important;
  font-size: 0.9rem !important;
  cursor: pointer !important;
  user-select: none !important;
`;

const ErrorText = styled.p`
  font-size: 16px !important;
  font-weight: 500 !important;
  color: ${colors.error} !important;
  margin: 10px 0 !important;
  padding: 0 !important;
  text-align: center !important;
`;

export default LoginWithPass;



// WEBPACK FOOTER //
// ./src/components/LoginNormal.js